import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "address_two" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = {
  for: "title",
  style: {"margin-left":"10px"}
}
const _hoisted_4 = {
  for: "title",
  style: {"margin-left":"10px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "manual"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "right" }
const _hoisted_9 = {
  key: 0,
  class: "manual"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"69px"} }, "Пример карты", -1)
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_YandexMap = _resolveComponent("YandexMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        (_ctx.document.mapfile_type == true)
          ? (_openBlock(), _createBlock(_component_v_switch, {
              key: 0,
              style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
              color: "#2F80ED",
              modelValue: _ctx.document.mapfile_type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.document.mapfile_type) = $event)),
              label: "Яндекс Карта"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", _hoisted_4, [
        (_ctx.document.mapfile_type == false)
          ? (_openBlock(), _createBlock(_component_v_switch, {
              key: 0,
              style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
              color: "#2F80ED",
              modelValue: _ctx.document.mapfile_type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.mapfile_type) = $event)),
              label: "Свой файл"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5,
      (0 == _ctx.document.mapfile_type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_FileUpload, {
              document: _ctx.document,
              file_upload_name: 'map_file',
              upload_text: 'Карта должна быть соотношением 1.5Шx1В, с сервиса РГИС, масштабом 1:2000 с указанным местом установки конструкции. Пример: 604px x 410px'
            }, null, 8, ["document", "upload_text"])
          ]))
        : _createCommentVNode("", true),
      (1 == _ctx.document.mapfile_type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_YandexMap, {
              document: _ctx.document,
              address_line: 
          'Санкт-Петербург, ' +
          _ctx.document.map_street +
          ' ' +
          _ctx.document.map_address +
          ', ' +
          _ctx.document.map_house
        
            }, null, 8, ["document", "address_line"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (0 == _ctx.document.mapfile_type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("img", {
              src: require('../../assets/images/exampleMap.jpg')
            }, null, 8, _hoisted_11)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}